import { node, shape } from "prop-types";
import React, { createContext } from "react";
import { Row } from "react-bootstrap";

export const TransactionContext = createContext({});
const { Provider } = TransactionContext;
export const Transaction = ({ children, transaction }) => (
    <Provider value={{ transaction }}>
        <div className="container transaction-ticket">
            <Row>{children}</Row>
        </div>
    </Provider>
);

Transaction.propTypes = {
    children: node.isRequired,
    transaction: shape({}).isRequired,
};
